import { useVeltClient } from '@veltdev/react';
import React, { useEffect } from 'react'
import './Widget.css';
import { getHash } from '../../utils/utils';

function Widget({ documentId, globalFilters, panelId }: { documentId: string, globalFilters: any, panelId: string }) {

    const chartOptions = ['bar', 'line'];

    const durationOptions = ['1d', '1w', '1m', '3m', '6m', '1y'];

    const [filters, setFilters] = React.useState<any>({
        chart: 'bar',
        duration: '1d',
    });

    const [veltLocationVariable, setVeltLocationVariable] = React.useState({});

    const { client } = useVeltClient();

    useEffect(() => {
        let allFilters = {};
        if (globalFilters) {
            allFilters = {
                ...allFilters,
                globalFilters,
            };
        }
        if (filters) {
            allFilters = {
                ...allFilters,
                filters,
            };
        }
        const location: any = {
            id: getHash(JSON.stringify(allFilters)),
            filters: allFilters,
            panelId,
        };
        const locationName = `P${panelId}: Gender: ${globalFilters?.gender}, Age: ${globalFilters?.age}, Chart: ${filters?.chart}, Duration: ${filters?.duration}`;
        location.locationName = locationName;
        setVeltLocationVariable(location);
    }, [globalFilters, filters, documentId]);

    useEffect(() => {
        addLocation();
    }, [veltLocationVariable, client]);

    const addLocation = () => {
        if (client) {
            client?.setLocation(veltLocationVariable, true);
        }
    };

    return (
        <>
            <div className='widget' data-velt-location={JSON.stringify(veltLocationVariable || {})}>
                <div>Panel {panelId}</div>
                {/* Filters ui */}
                {/* form with chart type select option */}
                <form className='d-flex gap-2'>
                    <div>Chart: </div>
                    <select
                        onChange={(e) => {
                            setFilters({ ...filters, chart: e.target.value });
                        }}>
                        {
                            chartOptions.map((chart, index) => {
                                return <option key={index} value={chart}>{chart}</option>
                            })
                        }
                    </select>
                    <div>Duration: </div>
                    <select
                        onChange={(e) => {
                            setFilters({ ...filters, duration: e.target.value });
                        }}>
                        {
                            durationOptions.map((duration, index) => {
                                return <option key={index} value={duration}>{duration}</option>
                            })
                        }
                    </select>
                </form>
            </div>
        </>
    )
}

export default Widget;